import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Tooltip,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import DialogTransition from './Common/DialogTransition';
import useOrganization from '../hooks/UseOrganization';

const AddBulkUserDialog = ({ open = false, handleClose, OnUploaded }) => {
  const orgName = useSelector((state) => state.common.orgName);
  const { uploadBulkUser } = useOrganization();
  const theme = useTheme();
  const [uploadedFile, setUploadedFile] = useState(undefined);
  const handleOnDropChange = useCallback(
    (acceptedFiles, rejectedFiles) => {
      if (rejectedFiles.length > 0) {
        console.log('invalide file');
      }
      if (acceptedFiles) {
        setUploadedFile(acceptedFiles[0]);
      }
    },
    [setUploadedFile]
  );
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'application/xlsx': ['.xlsx'],
      'text/csv': ['.csv'],
    },
    maxFiles: 1,
    onDrop: handleOnDropChange,
  });

  const handleUploadBulkUser = useCallback(() => {
    if (uploadedFile) {
      uploadBulkUser(orgName, uploadedFile).then(() => {
        OnUploaded();
        handleClose();
      });
    }
  }, [uploadBulkUser, orgName, uploadedFile, handleClose, OnUploaded]);

  return (
    <Dialog
      onClose={handleClose}
      maxWidth="sm"
      fullWidth={true}
      TransitionComponent={DialogTransition}
      open={open}
    >
      <DialogTitle>Upload Bulk User</DialogTitle>
      <IconButton
        onClick={handleClose}
        size="large"
        sx={{ position: 'absolute', right: 16, top: 8 }}
      >
        <CloseIcon style={{ color: theme.palette.other.icon }} />
      </IconButton>
      <DialogContent dividers>
        <Grid container justifyContent="center" textAlign="center">
          <Grid
            item
            {...getRootProps({ className: 'dropzone' })}
            id="dm_di_import_dts_all_type_fa_drop_box"
            sx={{
              border: `1px dashed ${theme.palette.primary.main} !important `,
              pt: '27px !important',
              borderRadius: '4px',
            }}
            width={403}
            height={200}
          >
            <UploadFileIcon
              sx={{ width: '60px', height: '60px', color: 'primary.main' }}
            />
            <br />
            <br />

            <input {...getInputProps()} hidden />
            <Grid container alignItems="center" justifyContent="center">
              {uploadedFile === undefined ? (
                <Box>
                  <Grid display="flex" flexDirection="row">
                    <Grid mr={1}>
                      <Typography variant="body2">
                        Drag and drop or choose a file to upload
                      </Typography>
                    </Grid>
                    <Grid mt={0.3}>
                      <Tooltip
                        title={
                          <Typography variant="body4">
                            File extensions .xlsx and .xls are allowed
                          </Typography>
                        }
                        placement="right-end"
                        arrow
                      >
                        <HelpOutlineIcon
                          sx={{
                            height: '14px',
                            width: '14px',
                            color: 'primary.main',
                          }}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Grid>
                  <Typography variant="body2">{uploadedFile?.name}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleUploadBulkUser}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddBulkUserDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  OnUploaded: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default AddBulkUserDialog;
